import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

export const ProjectSortTask = {
  state: {
    sortTasksBy: {
      selected: 'created',
      options: [
        {
          name: 'priority',
          value: 'priority'
        },
        {
          name: 'date added',
          value: 'created'
        },
        {
          name: 'task status',
          value: 'status'
        },
        {
          name: 'custom',
          value: 'custom'
        }
      ]
    },
    isTasksDragDisabled: false
  },
  mutations: {
    setSortTaskBy (state, payload) {
      state.sortTasksBy.selected = payload
    },

    setIsTasksDragDisabled (state, payload) {
      state.isTasksDragDisabled = payload
    }
  },
  actions: {
    updateSortTaskBy ({commit}, payload) {
      commit('setSortTaskBy', payload)
    },

    toggleIsTasksDragDisabled ({commit}, payload) {
      commit('setIsTasksDragDisabled', payload)
    },

    clearSortTask ({commit}) {
      commit('setSortTaskBy', 'created')
    },

    clearTasksDragDisabled ({commit}) {
      commit('setIsTasksDragDisabled', false)
    }
  },
  getters: {
    getSortTasksBy (state) {
      return state.sortTasksBy
    },
    
    getIsTasksDragDisabled (state) {
      return state.isTasksDragDisabled
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/ProjectSortTask.js